import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-h4 mb-4" }, "Добро пожаловать", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Вам доступны следующие действия:", -1)
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "ms-8 text-body-2 text-medium-emphasis" }

import { AppAuthService, CoreDict, TranslationService, getPermissionDescriptorByName } from '@prodcard/core'
import { useAuthPermissions } from '../../../mixins'

export default /*#__PURE__*/_defineComponent({
  __name: 'MainPage',
  props: {
    authService: {},
    translationService: {}
  },
  setup(__props: any) {

const props = __props;



const { currentUser, currentUserRole, currentUserPermissions } = useAuthPermissions(props.authService)

function getPermissionInfo(perm: string): string {
  const p = getPermissionDescriptorByName(perm)?.description
  return p ? `${props.translationService.tr('ru', p)}` : perm
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_unref(currentUser) === undefined)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Для дальнейшей работы не забудьте авторизоваться"))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(" Ваша роль в системе: "),
            _createElementVNode("b", null, _toDisplayString(_unref(currentUserRole)?.name), 1)
          ]),
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentUserPermissions).rolePermissions, (perm) => {
            return (_openBlock(), _createElementBlock("ul", {
              key: perm,
              title: perm
            }, [
              _createElementVNode("li", _hoisted_7, _toDisplayString(getPermissionInfo(perm)), 1)
            ], 8, _hoisted_6))
          }), 128))
        ]))
  ], 64))
}
}

})